import { useDebugValue } from 'react';
import { isNull } from 'utils/tsHelpers';
import { ElementType, useIndex } from '../../../contexts/elementIndex';

export const useClauseFieldPath = () => {
  const index = useIndex(ElementType.clause);
  const fieldPath = isNull(index)
    ? ('conditionalContent.ifClause' as const)
    : (`conditionalContent.elseIfClauses.${index}` as const);
  useDebugValue(fieldPath);
  return fieldPath;
};
